export const cardClasses = 'rounded-md border border-info-200 bg-white shadow-xs';

export const cardHeaderClasses = 'flex items-center justify-between gap-4 border-b border-info-100 px-4 py-3';

export const cardBodyClasses = 'flex flex-col gap-4 px-4 py-4';

export const sectionHeadingClasses = 'text-info-900 text-lg font-medium';

export const subtleTextClasses = 'text-info-500 text-sm';

export const getTabButtonClasses = (isActive: boolean) =>
  [
    'cursor-pointer px-4 py-2.5 -mb-px text-sm font-medium transition-colors border-b-2',
    isActive
      ? 'text-primary-600 border-primary-600'
      : 'text-info-600 border-transparent hover:text-info-900 hover:border-info-200',
  ].join(' ');

export const mutedBadgeClasses =
  'inline-flex items-center rounded-full border border-info-200 bg-info-50 px-2 py-0.5 text-xs font-medium text-info-600';

export const warnBadgeClasses =
  'inline-flex items-center rounded-full border border-warning-200 bg-warning-50 px-2 py-0.5 text-xs font-medium text-warning-700';

export const successBadgeClasses =
  'inline-flex items-center rounded-full border border-success-200 bg-success-50 px-2 py-0.5 text-xs font-medium text-success-700';
